import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CognitoState } from 'react-cognito';
import { EMPTY_OBJECT, RESPONSIVE_SIZE } from '../../constants';
import intercom from '../../lib/intercom';
import { getDisplayName } from '../../lib/react';
import { showSignup, logout } from '../../actions/user';
import { setRuntimeVariable } from '../../actions/runtime';
import { Brandmark } from '../Icons';
import Button from '../Button';
import Link from '../Link';
import Style from '../Style';
import { H5, H6, L4, P1, P2 } from '../Typography';

class MobileNav extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    loggedIn: PropTypes.bool,
    logout: PropTypes.func,
    showSignup: PropTypes.func,
    close: PropTypes.func,
    setScrollPrison: PropTypes.func,
  };
  static defaultProps = {};

  componentDidMount() {
    this.props.setScrollPrison(true);
  }

  componentWillUnmount() {
    this.props.setScrollPrison(false);
  }

  checkForClose = e => {
    if (e.target.tagName === 'A') {
      this.props.close();
    }
  };

  doAndClose = func => e => {
    this.props.close();
    func();
  };

  render() {
    const {
      responsive,
      loggedIn,
      logout,
      showSignup,
      close,
      ...otherProps
    } = this.props;

    let containerStyle = {
      backgroundColor: Style.Colors.black,
      color: Style.Colors.white,
      position: 'relative',
      padding: '0rem 8vw 4rem',
    };

    let brandmarkStyle = {
      display: 'block',
      fill: Style.Colors.white,
      maxWidth: '6.6rem',
      width: '100vw',
    };
    let navBrandmarkStyle = {
      ...brandmarkStyle,
      opacity: 1,
    };
    let centerBrandmarkStyle = {
      ...brandmarkStyle,
      opacity: 0,
    };

    let labelStyle = {
      opacity: 0.5,
      display: 'block',
      padding: '5rem 0 2rem',
    };

    let bottomRowStyle = {
      paddingTop: '4rem',
      display: 'flex',
      flexDirection: 'column',
    };

    let bottomCellStyle = {
      paddingTop: '1rem',
    };

    let navLinkStyle = {
      margin: '1rem 0',
    };

    let subLinkStyle = {
      margin: '0.5rem 0',
    };

    if (responsive >= RESPONSIVE_SIZE.PHONE) {
      containerStyle.padding = '0rem 8vw 7rem';
      labelStyle.padding = '8rem 0 2rem';
      delete navLinkStyle.margin;
      delete subLinkStyle.margin;
    }

    return (
      <div
        style={{
          position: 'fixed',
          zIndex: 500,
          top: 0,
          left: 0,
          minHeight: '100vh',
          width: '100vw',
          backgroundColor: Style.Colors.black,
          opacity: 1,
          pointerEvents: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div style={{ ...containerStyle }} onClick={this.checkForClose}>
          <div>
            <Brandmark style={{ ...navBrandmarkStyle }} />
            <L4 style={labelStyle}>STORYTAPE NAVIGATION</L4>
            <NavLink style={navLinkStyle} to="/">
              Home
            </NavLink>
            <NavLink style={navLinkStyle} to="/how-it-works">
              How it Works
            </NavLink>
            <NavLink style={navLinkStyle} to="/pricing">
              Pricing Plans
            </NavLink>
            <NavLink style={navLinkStyle} to="/browse">
              Browse Scenes
            </NavLink>
            <NavLink style={navLinkStyle} to="/legal">
              Privacy &amp; Terms
            </NavLink>
            <NavLink
              style={navLinkStyle}
              onClick={this.doAndClose(() => intercom.startConversation())}
            >
              Get Support
            </NavLink>

            {!loggedIn && (
              <Button
                size="large"
                style={{ marginTop: '5rem' }}
                baseColor={Style.Colors.black}
                onClick={this.doAndClose(showSignup)}
              >
                Sign Up
              </Button>
            )}
            {loggedIn && (
              <div>
                <NavLink style={navLinkStyle} to="/dashboard">
                  Dashboard
                </NavLink>
                <div style={{ paddingLeft: '2rem' }}>
                  <SubLink style={subLinkStyle} to="/dashboard/licenses">
                    Licensed Clips
                  </SubLink>
                  <SubLink style={subLinkStyle} to="/dashboard/subscription">
                    My Subscription
                  </SubLink>
                  <SubLink
                    style={subLinkStyle}
                    onClick={this.doAndClose(logout)}
                  >
                    Sign Out
                  </SubLink>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
    loggedIn: state.cognito.state === CognitoState.LOGGED_IN,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(logout()),
    showSignup: () => dispatch(showSignup()),
    setScrollPrison: locked =>
      dispatch(setRuntimeVariable('scrollPrison', locked)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileNav);

function NavLink(props) {
  const { style, ...otherProps } = props;
  return (
    <H5 style={style}>
      <Link {...otherProps}>{otherProps.children}</Link>
    </H5>
  );
}

function SubLink(props) {
  const { style, ...otherProps } = props;
  let merged = style || EMPTY_OBJECT;
  return (
    <H6 style={{ fontWeight: 400, ...merged }}>
      <Link {...otherProps}>{otherProps.children}</Link>
    </H6>
  );
}



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNav.js